import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class SidebarService {
    private toggleSubjects = new Map<number, BehaviorSubject<boolean>>();

    public toggle(sidebarId: number, open: boolean) {
        if (!open) {
            const filteredMap = new Map([...this.toggleSubjects.entries()].filter(([key]) => key > sidebarId));
            filteredMap.forEach((subject, key) => {
                subject.next(false);
            });
        }
    }

    public toggled(sidebarId: number): Observable<boolean> {
        let subject = this.toggleSubjects.get(sidebarId);
        if (!subject) {
            subject = new BehaviorSubject(null);
            this.toggleSubjects.set(sidebarId, subject);
        }
        return subject.asObservable();
    }
}
